var _defs, _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _g, _g2, _g3, _g4, _circle8, _circle9, _circle10, _text, _text2, _g5, _rect2, _text3, _text4, _text5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg4Personalization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 260",
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes core-pulse{0%,100%{r:32;opacity:.8}50%{r:38;opacity:1}}\n    @keyframes core-ring{0%{r:32;opacity:.5;stroke-width:2}100%{r:65;opacity:0;stroke-width:.5}}\n    @keyframes node-flow{0%,100%{opacity:.4;transform:scale(1)}50%{opacity:1;transform:scale(1.2)}}\n    @keyframes msg-out{0%,60%{opacity:0;transform:translateX(-10px)}70%,90%{opacity:1;transform:translateX(0)}100%{opacity:0}}\n    .n1{animation:node-flow 3s ease-in-out infinite 0s}\n    .n2{animation:node-flow 3s ease-in-out infinite .5s}\n    .n3{animation:node-flow 3s ease-in-out infinite 1s}\n    .n4{animation:node-flow 3s ease-in-out infinite 1.5s}\n    .cr{animation:core-ring 2.5s ease-out infinite}\n    .cr2{animation:core-ring 2.5s ease-out infinite .8s}\n    .msg{animation:msg-out 3s ease-in-out infinite 1s}\n  "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e-core",
    cx: "50%",
    cy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c3aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1d4ed8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e-bg-glow",
    cx: "50%",
    cy: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3b0764",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3b0764",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#06091a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a0618"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "e-glow-sm"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "in1",
    d: "M 100 80 Q 200 80 280 130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "in2",
    d: "M 100 130 L 280 130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "in3",
    d: "M 100 180 Q 200 180 280 130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "in4",
    d: "M 100 230 Q 200 230 280 130"
  }), /*#__PURE__*/React.createElement("path", {
    id: "out1",
    d: "M 320 130 Q 420 80 520 80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "out2",
    d: "M 320 130 Q 420 130 520 130"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 260,
    fill: "url(#e-bg)",
    rx: 20
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 130,
    r: 90,
    fill: "url(#e-bg-glow)",
    filter: "url(#e-glow)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 100 80 Q 200 80 280 130",
    fill: "none",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 130 L 280 130",
    fill: "none",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 180 Q 200 180 280 130",
    fill: "none",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 230 Q 200 230 280 130",
    fill: "none",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 320 130 Q 420 80 520 80",
    fill: "none",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 320 130 Q 420 130 520 130",
    fill: "none",
    stroke: "#1e1b4b",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#38bdf8",
    filter: "url(#e-glow-sm)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#in1"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#34d399",
    filter: "url(#e-glow-sm)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".5s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#in2"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".5s"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#fb923c",
    filter: "url(#e-glow-sm)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#in3"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "#f472b6",
    filter: "url(#e-glow-sm)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#in4"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.5s"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#a78bfa",
    filter: "url(#e-glow-sm)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#out1"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#c084fc",
    filter: "url(#e-glow-sm)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.8s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#out2"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;1;1;0",
    dur: "1.5s",
    repeatCount: "indefinite",
    begin: "1.8s"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "n1",
    "transform-origin": "100 80"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 80,
    r: 22,
    fill: "#0d1a2e",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 76,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "profit"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 87,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "$42"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "n2",
    "transform-origin": "100 130"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 130,
    r: 22,
    fill: "#0d1a2e",
    stroke: "#34d399",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 126,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "activity"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 137,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "18 acts"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "n3",
    "transform-origin": "100 180"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 180,
    r: 22,
    fill: "#0d1a2e",
    stroke: "#fb923c",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 176,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "features"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 187,
    textAnchor: "middle",
    fill: "#fb923c",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "3 used"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "n4",
    "transform-origin": "100 230"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 230,
    r: 22,
    fill: "#0d1a2e",
    stroke: "#f472b6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 226,
    textAnchor: "middle",
    fill: "#f472b6",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "avg"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 237,
    textAnchor: "middle",
    fill: "#f472b6",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "-12%"))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cr",
    cx: 300,
    cy: 130,
    r: 32,
    fill: "none",
    stroke: "#7c3aed"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cr2",
    cx: 300,
    cy: 130,
    r: 32,
    fill: "none",
    stroke: "#a78bfa"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 130,
    r: 34,
    fill: "url(#e-core)",
    filter: "url(#e-glow)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "32;36;32",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 126,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "JetBrains Mono",
    fontSize: 11,
    fontWeight: 700
  }, "AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 140,
    textAnchor: "middle",
    fill: "#ddd6fe",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "engine")), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "msg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 48,
    width: 185,
    height: 64,
    rx: 10,
    fill: "#0d1a2e",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 68,
    r: 11,
    fill: "#7c3aed"
  }), /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 72,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "JetBrains Mono",
    fontSize: 10
  }, "\uD83D\uDD14"), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 63,
    fill: "#c084fc",
    fontFamily: "JetBrains Mono",
    fontSize: 8,
    fontWeight: 700
  }, "Personalized"), /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 68,
    width: 135,
    height: 2,
    rx: 1,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 74,
    width: 110,
    height: 2,
    rx: 1,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 525,
    y: 80,
    width: 120,
    height: 2,
    rx: 1,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 102,
    fill: "#4c1d95",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "You are -12% this week \u2192"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 110,
    width: 130,
    height: 40,
    rx: 10,
    fill: "#0d1a2e",
    stroke: "#334155",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 128,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Next best")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 140,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "action hint")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 232,
    textAnchor: "middle",
    fill: "#1e293b",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "USER STATS \u2192 AI CORE \u2192 PERSONALIZED MESSAGE")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4Personalization);
export default __webpack_public_path__ + "static/media/svg4-personalization.5a23ad51d1cb2111f78f9269913b9e3d.svg";
export { ForwardRef as ReactComponent };